var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPublicHealthcare = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Hospital-Building--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Hospital Building Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9A4.5 4.5 0 1 0 3 4.5 4.51 4.51 0 0 0 7.5 9Zm-2 -5.25h0.75a0.5 0.5 0 0 0 0.5 -0.5V2.5a0.75 0.75 0 0 1 1.5 0v0.75a0.5 0.5 0 0 0 0.5 0.5h0.75a0.75 0.75 0 0 1 0 1.5h-0.75a0.5 0.5 0 0 0 -0.5 0.5v0.75a0.75 0.75 0 0 1 -1.5 0v-0.75a0.5 0.5 0 0 0 -0.5 -0.5H5.5a0.75 0.75 0 0 1 0 -1.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 13h3a0.5 0.5 0 0 0 0.5 -0.5V7a1.46 1.46 0 0 0 -1 -1.42 0.49 0.49 0 0 0 -0.63 0.36 6 6 0 0 1 -11.64 0 0.49 0.49 0 0 0 -0.63 -0.36A1.46 1.46 0 0 0 0 7v16a1 1 0 0 0 1 1h7a0.52 0.52 0 0 0 0.5 -0.58 2 2 0 0 1 0 -0.42v-7a3 3 0 0 1 3 -3ZM6 20.75H3a0.75 0.75 0 0 1 0 -1.5h3a0.75 0.75 0 0 1 0 1.5Zm0 -3.5H3a0.75 0.75 0 0 1 0 -1.5h3a0.75 0.75 0 0 1 0 1.5Zm0.5 -3.5H3a0.75 0.75 0 0 1 0 -1.5h3.5a0.75 0.75 0 0 1 0 1.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 14.5h-11A1.5 1.5 0 0 0 10 16v7a1 1 0 0 0 1 1h3.5a0.5 0.5 0 0 0 0.5 -0.5v-1a2 2 0 0 1 4 0v1a0.5 0.5 0 0 0 0.5 0.5H23a1 1 0 0 0 1 -1v-7a1.5 1.5 0 0 0 -1.5 -1.5Zm-7 3.75H13a0.75 0.75 0 0 1 0 -1.5h2.5a0.75 0.75 0 0 1 0 1.5Zm5.5 0h-2.5a0.75 0.75 0 0 1 0 -1.5H21a0.75 0.75 0 0 1 0 1.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPublicHealthcare);
export default ForwardRef;